import { Autocomplete, Paper, TextField } from "@mui/material";
import { useState, useEffect } from "react";

const AutoCompleteDropDown = ({
  data,
  onChange,
  value,
  label: label,
  dropDownDisplayLabel,
  defaultValue,
  placeholder,
  style,
  values,
  fullWidth,
  disabled,
}: AutoCompleteDropDownProps) => {
  const [initialOptions, setInitialOptions] = useState(data);
  const [filteredOptions, setFilteredOptions] = useState(data);

  useEffect(() => {
    setInitialOptions(data);
    setFilteredOptions(data);
  }, [data]);

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const filtered = initialOptions.filter((option: any) =>
      checkLabel(option, label).toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredOptions(filtered);
  };
  return (
    <>
      <Autocomplete
        style={style}
        fullWidth={fullWidth}
        disablePortal
        disabled={disabled}
        id="combo-box-demo"
        value={value}
        defaultValue={defaultValue}
        onChange={(event, newValue) => {
          if (onChange) {
            onChange(newValue);
          }
        }}
        options={filteredOptions}
        getOptionLabel={(option: any) => checkLabel(option, label)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={dropDownDisplayLabel}
            InputLabelProps={{ shrink: true }}
            style={{ color: "#000" }}
            placeholder={placeholder}
            value={values}
            onChange={handleFilterChange}
          />
        )}
        PaperComponent={(props) => (
          <Paper
            {...props}
            style={{
              ...props.style,
              border: " 1px solid #acacac",
            }}
          />
        )}
        size="small"
      />
    </>
  );
};
export default AutoCompleteDropDown;

interface AutoCompleteDropDownProps {
  data?: any;
  onChange?: (newValue: any | null) => void;
  value?: any;
  label?: any;
  dropDownDisplayLabel?: string;
  defaultValue?: any;
  placeholder?: string;
  style?: any;
  fullWidth?: boolean;
  values?: any;
  disabled?: any;
}

function checkLabel(option: any, label: string) {
  if (label === "name") {
    return option?.name;
  }
  if (label === "displayName") {
    return option?.displayName;
  }
  if (label === "firstName") {
    return option?.firstName;
  }
  if (label === "companyName") {
    return option?.companyName;
  }
  if (label === "timeZoneName") {
    return option?.timeZoneName;
  }
  if (label === "title") {
    return option?.title;
  }
}
